import React from 'react';

export const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-copy">
        <p className="footer-tagline">
          make your<span className="footer-tagline-mark">*</span>money unstoppable.
        </p>
        <p className="footer-disclaimer">
          USDN is issued by Coconut Financial Holdings Ltd (BVI). It is not a deposit and pays no
          interest. Redemption to fiat runs through licensed partners and is subject to their
          KYC/AML checks. Swaps execute onchain and are final.
        </p>
      </div>
      <nav className="footer-nav" aria-label="Footer">
        <a href="https://usdnova.com">Reserves</a>
        <a href="https://usdnova.com">White paper</a>
        <a href="https://x.com/getnovausd">@getnovausd</a>
        <span className="footer-domain">usdnova.com</span>
      </nav>
    </footer>
  );
};
